import React from 'react';
// import Cards from '../../components/cards';
// import Header from '../../components/header';
import Nav from '../../components/nav';
import Footer from '../../components/footer';
import AboutComponent from '../../components/about';
import "./styles_about.css";
import "./reset.css";
// import "./dark.css";
// ... otras importaciones ...

// Cambiamos el nombre de esta función para evitar conflictos
function AboutPage() {
  return (
    <div className='App'>
      <div className='fondoImg'></div>
      <div className='fondo'></div>
      <div className='fondo2'></div>
      <div className='fondo3'></div>
      <Nav/>
      <AboutComponent/>
      <hr style={{marginTop: '50px', height: '10px', backgroundColor: '#848688'}} />
      <Footer/>
    </div>
  );
}

// Actualizamos el nombre de la exportación
export default AboutPage;
